/* unplugin-vue-components disabled */import { render } from "./ai-select.vue?vue&type=template&id=a099254a&scoped=true"
import script from "./ai-select.vue?vue&type=script&lang=js"
export * from "./ai-select.vue?vue&type=script&lang=js"

import "./ai-select.vue?vue&type=style&index=0&id=a099254a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a099254a"],['__file',"src/components/ai-chat/ai-assistant/ai-input/ai-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a099254a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a099254a', __exports__)) {
    api.reload('a099254a', __exports__)
  }
  
  module.hot.accept("./ai-select.vue?vue&type=template&id=a099254a&scoped=true", () => {
    api.rerender('a099254a', render)
  })

}


export default __exports__